import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function RequireAuth({ children }) {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    let ativo = true;

    fetch(`${API_BASE}painel-dados.php`, {
      method: "GET",
      credentials: "include", // 🔴 ESSENCIAL para sessão PHP
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(async (res) => {
        try {
          return await res.json();
        } catch {
          return null;
        }
      })
      .then((data) => {
        if (!ativo) return;

        // 🔐 Regra real baseada no SEU backend
        if (data && data.status === "sucesso") {
          setAuthenticated(true);
        } else {
          setAuthenticated(false);
        }

        setLoading(false);
      })
      .catch(() => {
        if (!ativo) return;
        setAuthenticated(false);
        setLoading(false);
      });

    return () => {
      ativo = false;
    };
  }, []);

  // ⏳ Enquanto valida a sessão
  if (loading) {
    return null; // ou um spinner, se quiser depois
  }

  // 🚫 Sem sessão → login
  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Sessão válida → libera a rota
  return children;
}
